import FullParagraphAndTagsHomepageFirstFoldConfig from "./full-paragraph-and-tags-homepage-first-fold-config";
import FullParagraphAndTagsHomepageFirstFoldAdvancedConfig from "./full-paragraph-and-tags-homepage-first-fold-advanced-config";
import dynamic from "next/dynamic";
const FullParagraphAndTagsHomepageFirstFoldComponent = dynamic(()=>import("./full-paragraph-and-tags-homepage-first-fold-component"));
export default {
    FullParagraphAndTagsHomepageFirstFoldComponent,
    FullParagraphAndTagsHomepageFirstFoldConfig,
    FullParagraphAndTagsHomepageFirstFoldAdvancedConfig
};
